import React from 'react';

import { IconButton, makeStyles } from '@material-ui/core';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import Transition from 'react-transition-group/Transition';

import styles from './styles.module.scss';

const animationDuration = 300;
const additionalStyle = {
  transition: `all ${animationDuration}ms ease-out`,
};
const transitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

const useStyles = makeStyles(() => ({
  closeButton: {
    position: 'absolute',
    top: 4,
    right: 4,
    border: '1px solid var(--color-white)',
    padding: 0,
    color: 'var(--color-white)',
    marginLeft: '20px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

export function TipPopOut({ text, visible, onClose }) {
  const iconStyles = useStyles();

  return (
    <Transition in={visible} timeout={animationDuration}>
      {(state) => (
        <div
          className={styles.container}
          style={{ ...additionalStyle, ...transitionStyles[state] }}
        >
          <IconButton
            aria-label="close"
            size="small"
            className={iconStyles.closeButton}
            onClick={onClose}
          >
            <CloseOutlinedIcon fontSize="small" />
          </IconButton>
          <p className={styles.text}>{text}</p>
        </div>
      )}
    </Transition>
  );
}
